export default __webpack_public_path__ + "static/media/assign.bb8f8df7.svg";